import {api} from "@/data/api/portal"

export interface Licence {
  env: string;
  app: string;
  expiry: string;
  count: number;
  lastUpdated: string;
}

export async function getLicences() {
  const r = await api.get("/licences")
  return r.data as Licence[]
}
